module.exports = __webpack_public_path__ + "static/media/g-1-b.442ab360.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gadgets/g-1-b.jpg
// module id = 1125
// module chunks = 33